import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M235.096763,255 L235.096763,1665.58058 L0,1665.58058 L0,255 L235.096763,255 Z M1013.93707,289.406411 L1180.26803,455.619823 L793.181214,842.706643 L1920,842.706643 L1920,1077.80341 L793.181214,1077.80341 L1180.26803,1464.89023 L1013.93707,1631.10364 L343.088461,960.255025 L1013.93707,289.406411 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMoveLeftSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMoveLeftSolid, _Component);

  var _super = _createSuper(IconMoveLeftSolid);

  function IconMoveLeftSolid() {
    _classCallCheck(this, IconMoveLeftSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMoveLeftSolid, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {}

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMoveLeft",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconMoveLeftSolid.displayName = "IconMoveLeftSolid";
  return IconMoveLeftSolid;
}(Component);

IconMoveLeftSolid.glyphName = 'move-left';
IconMoveLeftSolid.variant = 'Solid';
IconMoveLeftSolid.deprecated = true;
IconMoveLeftSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMoveLeftSolid;
export { IconMoveLeftSolid };